var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c(
        "div",
        { staticClass: "content" },
        [
          _c("SelectedStore", {
            attrs: { "selected-store-id": _vm.shopId },
            on: {
              "create-zone": _vm.createZone,
              "edit-zone": _vm.editZone,
              "remove-zone": _vm.deleteZone
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("AddStoreModal", {
        attrs: { "is-open": _vm.addModal },
        on: {
          close: function($event) {
            _vm.addModal = false
          }
        }
      }),
      _vm._v(" "),
      _c(
        "keep-dom-dialog",
        {
          on: { close: _vm.clearZoneComponent },
          model: {
            value: _vm.areaDialogShow,
            callback: function($$v) {
              _vm.areaDialogShow = $$v
            },
            expression: "areaDialogShow"
          }
        },
        [_c("div", { attrs: { id: "module-area" } })]
      ),
      _vm._v(" "),
      _c("confirm-dialog", {
        ref: "confirmDialog",
        attrs: { open: _vm.confirm },
        on: {
          cancel: function($event) {
            _vm.confirm = false
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }